import { ExitToAppOutlined } from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Fragment, useEffect, useState } from 'react';
import { BRANDING } from '../config/branding';

const styleDefault = { width: 180, height: '100%', background: 'background.default' }

const CustomDrawer = ({ open, options, onExit, anchor = 'left', style = styleDefault, isDefault = true, listItems, tittle, icon, onTabClick }) => {
  const [items, setItems] = useState(options || []);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  useEffect(() => {
    const nextItems = [...(options || [])];
    if (!nextItems.some((item) => item.tittle === 'Salir')) {
      nextItems.push({ tittle: 'Salir', icon: <ExitToAppOutlined /> });
    }
    setItems(nextItems);
  }, [options])

  const clickHandler = (tittle, path, icon) => {
    console.log(path);
    console.log(tittle);
    if(path) {
      // Usar el sistema de pestañas
      if (onTabClick) {
        onTabClick({ title: tittle, path, icon });
      }
    } else if (tittle === 'Salir') {
      onExit && onExit();
    }
  }

  const list = (anchor) => (
    <Box
      sx={style}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
    >
      <List>
        {items?.map(({ tittle, path, icon }, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton onClick={() => clickHandler(tittle, path, icon)} sx={{ py: 0, minHeight: 32 }}>
              <ListItemIcon sx={{ color: 'inherit' }}>
                {icon}
              </ListItemIcon>
              <ListItemText primary={tittle} primaryTypographyProps={{ fontSize: 14, fontWeight: 'medium' }}/>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <Box display='flex' flexDirection='column' sx={{ textAlign: 'center' }}>
        <img src={BRANDING.logoUrl} alt="Logo" style={{ maxWidth: '100%', height: 'auto' }} />
        {/* <Typography variant="body2">Pie del Drawer</Typography> */}
      </Box>
    </Box>
  );

  return (
    <Box sx={{ alignSelf: 'self-end' }}>
      <Fragment key={anchor}>
        <Button startIcon={isDefault ? <MenuIcon/> : icon } onClick={toggleDrawer(anchor, true)} sx={{ alignItems: 'start' }}>{tittle}</Button>
        <Drawer
          anchor={anchor}
          open={state[anchor]}
          onClose={toggleDrawer(anchor, open)}
          title='sss'
        >
          {isDefault ? list(anchor) : listItems}
        </Drawer>
      </Fragment>
    </Box>
  );
}

export default CustomDrawer;